import React from 'react';
import classNames from 'classnames';

import css from './CountryFlag.module.css';

const normalizeCountryCode = countryCode =>
  typeof countryCode === 'string' && /^[a-z]{2}$/i.test(countryCode.trim())
    ? countryCode.trim().toLowerCase()
    : null;

/**
 * Render a local SVG country flag for a two-letter ISO country code.
 *
 * The flag is decorative next to a visible country name, so it is hidden from assistive tech.
 */
const CountryFlag = props => {
  const { className, countryCode } = props;
  const normalizedCode = normalizeCountryCode(countryCode);

  return normalizedCode ? (
    <span className={classNames(css.root, className)}>
      <img
        className={css.image}
        src={`/static/flags/${normalizedCode}.svg`}
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
      />
    </span>
  ) : null;
};

export default CountryFlag;
